export default __webpack_public_path__ + "static/media/bg_02.7a96ce7c.png";